import {
  DrawerActions,
  DrawerContent,
  DrawerHeader,
  DrawerHeaderProps,
} from "@/components/common/drawer";

type Props = {
  headerProps: DrawerHeaderProps;
  content: React.ReactNode;
  actions?: React.ReactNode;
};

export const DrawerLayout = ({ headerProps, content, actions }: Props) => (
  <>
    <DrawerHeader {...headerProps} />
    <DrawerContent
      sx={{
        flex: 1,
        overflowY: "overlay",
        overflowX: "hidden",
        p: 2,
        scrollbarGutter: "stable",
        width: {
          xs: "100%",
          md: "400px",
        },
      }}
    >
      {content}
    </DrawerContent>
    {actions && <DrawerActions>{actions}</DrawerActions>}
  </>
);
